<template>
  <article class="layout-section -bg-primary">
    <section v-for="entry in wp.sections" :key="entry.years" class="layout-section__content">
      <div class="layout-section__hgroup -full">
        <h4 class="layout-section__uptitle">{{ entry.years }}</h4>
        <h3 class="layout-section__title -small">{{ entry.title }}</h3>
      </div>

      <div class="rte" v-html="entry.content" />
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutHistoryIndex',
  inject: ['wp']
}
</script>
